import _slicedToArray from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
// Copyright 2017-2021 @polkadot/types authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { assert, compactFromU8a, logger, u8aToU8a } from '@polkadot/util';
import { AbstractArray } from "./AbstractArray.mjs";
import { decodeU8a, typeToConstructor } from "./utils/index.mjs";
var MAX_LENGTH = 64 * 1024;
var l = logger('Vec');
/**
 * @name Vec
 * @description
 * This manages codec arrays. Internally it keeps track of the length (as decoded) and allows
 * construction with the passed `Type` in the constructor. It is an extension to Array, providing
 * specific encoding/decoding on top of the base type.
 */

export var Vec =
/*#__PURE__*/
function (_AbstractArray) {
  _inherits(Vec, _AbstractArray);

  function Vec(registry, Type) {
    var _getPrototypeOf2;

    var _this;

    var value = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

    _classCallCheck(this, Vec);

    var Clazz = typeToConstructor(registry, Type);
    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Vec)).call.apply(_getPrototypeOf2, [this, registry].concat(_toConsumableArray(Vec.decodeVec(registry, Clazz, value)))));
    _this._Type = void 0;
    _this._Type = Clazz;
    return _this;
  }
  /** @internal */


  _createClass(Vec, [{
    key: "indexOf",

    /**
     * @description Finds the index of the value in the array
     */
    value: function indexOf(_other) {
      // convert type first, this removes overhead from the eq
      var other = _other instanceof this._Type ? _other : new this._Type(this.registry, _other);

      for (var i = 0; i < this.length; i++) {
        if (other.eq(this[i])) {
          return i;
        }
      }

      return -1;
    }
    /**
     * @description Returns the base runtime type name for this instance
     */

  }, {
    key: "toRawType",
    value: function toRawType() {
      return "Vec<".concat(this.registry.getClassName(this._Type) || new this._Type(this.registry).toRawType(), ">");
    }
  }, {
    key: "Type",

    /**
     * @description The type for the items
     */
    get: function get() {
      return this._Type.name;
    }
  }], [{
    key: "decodeVec",
    value: function decodeVec(registry, Type, value) {
      if (Array.isArray(value)) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return value.map(function (entry, index) {
          try {
            return entry instanceof Type ? entry : new Type(registry, entry);
          } catch (error) {
            l.error("Unable to decode on index ".concat(index), error.message);
            throw error;
          }
        });
      }

      var u8a = u8aToU8a(value);

      var _compactFromU8a = compactFromU8a(u8a),
          _compactFromU8a2 = _slicedToArray(_compactFromU8a, 2),
          offset = _compactFromU8a2[0],
          length = _compactFromU8a2[1];

      assert(length.lten(MAX_LENGTH), "Vec length ".concat(length.toString(), " exceeds ").concat(MAX_LENGTH));
      return decodeU8a(registry, u8a.subarray(offset), new Array(length.toNumber()).fill(Type));
    }
  }, {
    key: "with",
    value: function _with(Type) {
      return (
        /*#__PURE__*/
        function (_Vec) {
          _inherits(_class, _Vec);

          function _class(registry, value) {
            _classCallCheck(this, _class);

            return _possibleConstructorReturn(this, _getPrototypeOf(_class).call(this, registry, Type, value));
          }

          return _class;
        }(Vec)
      );
    }
  }]);

  return Vec;
}(AbstractArray);